import * as React from 'react';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { TextFormGroup, RichTextFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { EditorState } from 'draft-js';
import { VejledningAfsnit } from '../../models/VejledningAfsnit';
import { SectionDynamic } from '../../uiComponents/layout/SectionDynamic';

export interface VejledningAfsnitEditProps {
    afsnit: VejledningAfsnit;
    errorMessages: ValidationError[];
    index: number;
    editorState: EditorState;
    onAfsnitChanged: (index: number, fieldName: string, value: any) => void;
    onEditorChanged: (index: number, editorState: EditorState) => void;
    onAfsnitRemoved: (index: number) => void;
}

export default class VejledningAfsnitEdit extends React.Component<VejledningAfsnitEditProps, any> {
    onChange = (fieldName: string, value: any) => {            
        this.props.onAfsnitChanged(this.props.index, fieldName, value);
    }

    onEditorChange = (editorState: EditorState, index: number) => {
        this.props.onEditorChanged(this.props.index, editorState);
    }

    render() {
        return (
            <SectionDynamic index={this.props.index} deleteOnClick={() => this.props.onAfsnitRemoved(this.props.index)}>
                <Row>
                    <Col md={6} mdOffset={3}>
                        <TextFormGroup
                            errorMessages={this.props.errorMessages}
                            label='Overskrift'
                            name='overskrift'
                            placeholder='Skriv overskrift...'
                            value={this.props.afsnit.overskrift}
                            onChange={this.onChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6} mdOffset={3}>
                        <RichTextFormGroup
                            onEditorChange={(editorState: EditorState) => this.onEditorChange(editorState, this.props.index)}
                            editorState={this.props.editorState}
                        />
                    </Col>
                </Row>
            </SectionDynamic>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Vejledning/VejledningAfsnitEdit.tsx